export default "__VITE_ASSET__ibaIsG9M__"